import { createStore, applyMiddleware } from 'redux';
import { sagas } from './Saga';
import reducer from './Reducers';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';

export const browserHistory = createBrowserHistory();
const reduxRouterMiddleware = routerMiddleware(browserHistory);

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger();

export const store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(sagaMiddleware, reduxRouterMiddleware, logger)),
);

sagaMiddleware.run(sagas);



// WEBPACK FOOTER //
// ./src/Store/index.js